import { render } from "./ModalRegister.vue?vue&type=template&id=f772e606&scoped=true"
import script from "./ModalRegister.vue?vue&type=script&lang=js"
export * from "./ModalRegister.vue?vue&type=script&lang=js"

import "./ModalRegister.vue?vue&type=style&index=0&id=f772e606&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f772e606"]])

export default __exports__